import { useContext } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { getSecureUserPhone } from '../../services/authUtils';
import i18nContext from '../i18n-context';

const UserDetails = ({ email, userId }) => {
  const i18n = useContext(i18nContext);
  // A user registered by email has no phone number (and a phone-registered one may have no email), so each of
  // these rows is shown only when there's something to show.
  const phone = getSecureUserPhone();
  return (
    <div className='wrapper'>
      <div className='settings-container-user'>
        <div className='profile-wrapper'>
          <div className='profile-info-wrapper left'>
            <p className='profile-header'>{i18n.getMessage('settings.title.userID')}</p>
            <p className='profile-info'>{userId}</p>
          </div>
        </div>
        {email && (
          <div className='profile-wrapper'>
            <div className='profile-info-wrapper left'>
              <p className='profile-header'>{i18n.getMessage('settings.title.email')}</p>
              <p className='profile-info'>{email}</p>
            </div>
          </div>
        )}
        {phone && (
          <div className='profile-wrapper'>
            <div className='profile-info-wrapper left'>
              <p className='profile-header'>{i18n.getMessage('settings.title.phoneNumber')}</p>
              <p className='profile-info'>{phone}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

UserDetails.propTypes = {
  email: PropTypes.string,
  userId: PropTypes.string
};

export default inject((stores) => ({
  email: stores.userStore.userData?.email,
  userId: stores.userStore.userData?.user_id
}))(observer(UserDetails));
